<ifc-base-dialog [title]="data.dialogTitle"
                 [actions]="actions"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <p class="heading">
      {{ data.heading}}
    </p>
    <div class="changes">
      <ng-container *ngFor="let fieldData of data?.fields">
        <ng-container *ngTemplateOutlet="field; context: fieldData"></ng-container>
      </ng-container>
      <ng-template #field
                   let-isChanged="isChanged"
                   let-label="label"
                   let-value="value">
        <div *ngIf="isChanged"
             class="change">
          <div>{{value}}</div>
          <div class="change__label">{{label}}</div>
        </div>
      </ng-template>
    </div>
  </ng-template>
</ifc-base-dialog>
